






import { Component, Mixins } from "vue-property-decorator";
import { ISourcePrintable } from "..";
import { SourcePrintableMixin } from "../mixins";

@Component({
})
export default class InternetExplorerPdfPrinter extends Mixins(SourcePrintableMixin) implements ISourcePrintable {
  data(): any {
    return {
      isLoaded: true,
    };
  }
  isLoaded: boolean;

  printSource(source: string, copies: number, shouldSelectPrinter: boolean) {
    // 部数と出力先はブラウザ任せなので無視.
    if (source === "") {
      return;
    }
    this.sourceToPrint = null;  // v-ifで1度objectをDOMから削除を促す
    this.$nextTick(() => {
      this.isLoaded = false;
      this.sourceToPrint = source;
      this.$nextTick(() => {
        this.$logger.debug("PDFPrint Loading");
        this.onLoading(); // IEの場合、チェック処理を起動
      });
    });
  }

  onLoading(): void {
    const ie = this.$refs.ie as any;  // HTMLEmbedElementだがprintWithDialogを使用するためany
    if (ie === undefined) {
      this.$logger.debug("PDFPrint instance undefined");
      return;
    }
    try {
      // 印刷開始
      ie.printWithDialog(); // printAllにすればダイアログを出さずに印刷も可能
      this.isLoaded = true; // 読み込み完了と言うより初期化完了のタイミングのためもう一工夫必要かも
      this.$logger.debug("PDFPrint Loaded");
    } catch {
      setTimeout(() => this.onLoading(), 1000); // 印刷できるまで定期的に呼び出す
      this.$logger.debug("PDFPrint Retry");
    }
  }
}
